import styled, { css } from 'styled-components'
// material
import Paper, { PaperProps } from '@mui/material/Paper'
// themes
import { colors } from 'themes/index'

export const TableWrapper = styled(Paper)<PaperProps & { isLoading?: boolean }>`
  overflow: auto;
  height: 100%;
  display: flex;
  flex-direction: column;

  ${({ isLoading }) =>
    isLoading &&
    css`
      .MuiTable-root {
        height: 100%;
      }

      .MuiTableBody-root {
        position: relative;

        > div {
          position: absolute;
        }
      }
    `};

  .MuiTablePagination-root {
    left: 0;
    bottom: 0;
    overflow: unset;
    margin-top: auto;
    position: sticky;
    background: ${colors.white100};
  }
`
